(function() { window.GUID_eae1c35d_7c5e_43c9_8dfe_2b23408f86f4 = { getGuid: function() { return "eae1c35d-7c5e-43c9-8dfe-2b23408f86f4"; } }; })();
var CS;
(function (CS) {
    var App;
    (function (App) {
        var Views;
        (function (Views) {
            var _Shared;
            (function (_Shared) {
                var WallSections;
                (function (WallSections) {
                    CS.Controls.ControlBase.BaseEvents.ControlBaseLoaded(CS.Controls.Accordion, {
                        selector: 'body',
                        childSelector: '.accordion-messages',
                        //context: null,
                        callback: function (control, e) {
                            control.$Container.offon('click.message-box', '.message-box', function () {
                            });
                        }
                    });
                })(WallSections = _Shared.WallSections || (_Shared.WallSections = {}));
            })(_Shared = Views._Shared || (Views._Shared = {}));
        })(Views = App.Views || (App.Views = {}));
    })(App = CS.App || (CS.App = {}));
})(CS || (CS = {}));

//# sourceMappingURL=messages.js.map
